/* @flow */
import actionTypes from './actionTypes';

export function push(pathname: string) {
  return {
    payload: { pathname },
    type: actionTypes.PUSH,
  };
}



// WEBPACK FOOTER //
// ./src/core/router/actions.js